import { SliderCarousel } from '@/components/blocks/SliderCarousel/SliderCarousel';
import { Section } from '@/components/layout/Section';

import type { CourseCardProps } from '@/components/page/courses/CourseCard';
import type { SanityProgrammeCarouselNewType } from '@/types/sanity';
import type {
  BlockWithAudience,
  ProgrammeB2BType,
  ProgrammeB2CType,
} from '@/types/shared';

export interface CourseCarouselProps
  extends Omit<SanityProgrammeCarouselNewType, 'programmes' | '_type'>,
    BlockWithAudience {
  programmes: Array<ProgrammeB2CType | ProgrammeB2BType>;
}

export const CourseCarousel = ({
  programmes,
  blockSpacing,
  paddingAdjustment,
  pageAudience,
  isAudienceSwitcherEnabled,
}: CourseCarouselProps) => {
  const slides = programmes?.map((programme): CourseCardProps => {
    return {
      ...programme?.programmeCard,
      _type: 'programmeCard',
      slug: programme?.slug,
      audienceRef: programme.audienceRef,
      pageAudience,
      isAudienceSwitcherEnabled,
      b2cAudience:
        programme._type === 'programmeB2C' ? programme?.b2cAudience : null,
    };
  });

  return (
    <Section
      className="course-carousel"
      spacing={blockSpacing}
      verticalPadding={paddingAdjustment ?? true}
    >
      <SliderCarousel
        slides={slides}
        slidesPerView={{
          '549px': 1.01,
          '849px': 2.01,
          '1279px': 3.01,
          max: 4.01,
        }}
        slidesPerGroup={{ '460px': 1, '700px': 2, '1200px': 3, max: 4 }}
        addSection={false}
        pageAudience={pageAudience}
        isAudienceSwitcherEnabled={isAudienceSwitcherEnabled}
      />
    </Section>
  );
};
